var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 108,
    viewBox: "0 0 105 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_77_2627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.67188,
    y: 0.834961,
    width: 93.3333,
    height: 93.3333,
    rx: 26.6667,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.33854,
    y: 1.50163,
    width: 92,
    height: 92,
    rx: 26,
    stroke: "#F1F3F7",
    strokeWidth: 1.33333,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0057 86.4173H25.1168V78.6395H64.0057V86.4173ZM91.2279 16.3901L72.814 39.5484L71.9585 40.5984L50.064 68.5595C49.3414 69.2822 48.4835 69.8554 47.5393 70.2465C46.5952 70.6376 45.5832 70.8389 44.5612 70.8389C43.5393 70.8389 42.5273 70.6376 41.5832 70.2465C40.639 69.8554 39.7811 69.2822 39.0585 68.5595C38.3358 67.8369 37.7626 66.979 37.3715 66.0348C36.9804 65.0907 36.7791 64.0787 36.7791 63.0567C36.7791 62.0348 36.9804 61.0228 37.3715 60.0787C37.7626 59.1345 38.3358 58.2766 39.0585 57.554L91.2279 16.3901ZM15.9585 28.9667C10.34 37.9634 8.31956 48.7475 10.3001 59.1679H13.4501V55.279C13.4115 47.6222 15.7037 40.135 20.0224 33.8123L15.9585 28.9667ZM52.339 8.6123C46.3915 8.61196 40.5097 9.85636 35.0719 12.2655C29.6341 14.6746 24.7607 18.1951 20.7651 22.6006L25.214 27.9012C30.4937 23.0475 37.3897 20.3306 44.5612 20.279C51.7717 20.3285 58.7031 23.0722 63.994 27.9712L77.7996 17.0745C70.4476 11.5815 61.5164 8.61312 52.339 8.6123ZM78.9001 44.3901L77.994 45.5062L75.1629 49.1229C75.4957 51.1581 75.666 53.2167 75.6724 55.279V59.1679H94.3779C96.223 49.4355 94.5949 39.3643 89.7774 30.709L78.9001 44.3901Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_77_2627",
    x: 0.338542,
    y: 0.834961,
    width: 103.999,
    height: 106.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_2627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_2627",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2);
export default __webpack_public_path__ + "static/media/c2.28ff3de5fee5d0752eec16ecb2a33858.svg";
export { ForwardRef as ReactComponent };